<div class="fixed bottom-6 right-6 z-50">
  <div class="flex flex-col items-end space-y-3">

    <button class="tour-floating-btn" (click)="startTour()" title="Start application tour">
      <div class="flex items-center space-x-3">
        <div class="tour-icon-container">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z" />
          </svg>
        </div>
        <span class="tour-text">Start Tour</span>
      </div>
    </button>


    <button *ngIf="hasSeenTour()" class="tour-reset-btn" (click)="resetTourSetting()"
      title="Show tour again on next visit">
      <div class="flex items-center space-x-3">
        <div class="tour-icon-container">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
          </svg>
        </div>
        <span class="tour-text">Show Again</span>
      </div>
    </button>
  </div>
</div>
